import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessStartProcessTestPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessStartProcessTestProperties = {
    [name in keyof EntityCommandProcessStartProcessTestPropertyValues]: Property<EntityCommandProcessStartProcessTestPropertyValues[name]>
};

export interface IEntityCommandProcessStartProcessTest extends IEntityCommand, EntityCommandProcessStartProcessTestProperties
{
}

export class EntityCommandProcessStartProcessTest extends EntityCommand implements IEntityCommandProcessStartProcessTest
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessStartProcessTest";
    public static override className = "EntityCommandProcessStartProcessTest";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessStartProcessTestPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Start Process Test",
                entityName: "Process",
                key: "START_PROCESS_TEST",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructors

    constructor(propertyValues?: PartialNullable<EntityCommandProcessStartProcessTestPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        await (
            ServiceManager.getRequired(WebApiClientService)
                .createApiMethodRequest("DataService", "CallDataService", { id: "b6b64018-f8a2-4c96-a6a8-8e037e2170c2", operation: "StartProcess" })
                .executeAsync()
        );
    }

    // #endregion

    // #endregion
}

